<template>
	<div>
		<div class="baidu-report">
			<div class="content">
				<ProjSelect ref="projSelect"></ProjSelect>
				<div class="report">
					<data-info></data-info>
					<div class="sub-report">
						<DatePicker></DatePicker>
						<data-view></data-view>
						<search-term></search-term>
						<div class="clear"></div>
						<div class="show-baidu-report">
<!--							<a class="formbtn" @click="jumpBaidu" href="javascript:;">-->
<!--								<span>查看更多</span>-->
<!--							</a>-->
						</div>
					</div>
				</div>

			</div>
		</div>
		<yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import mixinsDialog from '../../mixins/mixinsDialog.js'
import DataInfo from './component/DataInfo'
import DatePicker from './component/DatePicker'
import DataView from './component/DataView'
import SearchTerm from './component/SearchTerm'
import ProjSelect from './component/ProjSelect'

export default {
	name: 'baiduFlowCount',
	data () {
		return {}
	},
	mixins: [mixinsDialog],
	components: {
		DataInfo,
		DatePicker,
		DataView,
		SearchTerm,
		ProjSelect
	},
	computed: {
		...mapState('siteStas', ['flowData', 'curProjId']),
		...mapGetters('siteStas', ['getErrTips']),
	},
	methods: {
		...mapActions('siteList', ['getProjList']),
		...mapActions('siteStas', ['getBaiduAccount']),
		jumpBaidu () {
			if (this.flowData.baiduApi) {
				window.open(this.flowData.baiduApi)
			} else {
				this.openErrDialog('warn', '操作信息提示', 'jumpSet', this.getErrTips.jumpCur, this.getErrTips.info, this.getErrTips.btnName)
			}
		},
		jumpSet (val) {
			this.$refs.projSelect.jumpSetBaiduAccount(val)
		}
	}
}
</script>

<style lang="scss" scoped>
.baidu-report {
	.content {
		padding-top: 20px;
	}

	.clear {
		clear: both;
	}
	.show-baidu-report {
		text-align: center;
		padding-top: 10px;
	}

	.report-btn {
		display: inline-block;
		width: 300px;
		height: 50px;
		line-height: 50px;
		text-align: center;
		background-color: #f2f2f2;
		font-size: 16px;
		cursor: pointer;
	}
}
.sub-report{
	padding: 16px 20px;
	background:rgba(255,255,255,1);
	border-radius:4px;
}
</style>
